import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { LocationGroupRepository } from '../../repositories/location-group.repository';
import { CreateLocationGroup } from '../../domain/requests/location-group/create-location-group-request';
import { BaseResponse } from 'planning-portal-library/src/lib/data/shared/base.response';

@Injectable({ providedIn: 'root' })
export class CreateLocationGroupUseCase implements UseCase<CreateLocationGroup, BaseResponse<string>> {
  constructor(private readonly locationGroupRepository: LocationGroupRepository) {}

  execute(params: CreateLocationGroup): Observable<BaseResponse<string>> {
    return this.locationGroupRepository.CreateLocationGroup(params);
  }
}
